/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {
  Field,
  reduxForm
} from 'redux-form';

// app
import Input from 'components/Input';
import LabeledInput from 'components/LabeledInput';
import InputGroup from 'components/InputGroup';
// images deletion actions

// local
import styles from '../styles.module.css';
import validator from '../validator';

/*
Field Validators
------------------------------------------------------------
*/

/*
Edit Profile Form
================================================================================
*/

@reduxForm({
  form: 'out-of-network-tab4',
  enableReinitialize:true,
  validate: validator,
})
@CSSModules(styles, { allowMultiple: true })
export default class Tab4 extends React.Component {

  constructor (props) {
    super(props);
    this.submitRef = React.createRef();

    this.state={
      discount:0,
      writeOffOne: '',
      writeOffOneReimbursment: 0,
      writeOffTwo:'',
      writeOffTwoReimbursment: 0,
      writeOffThree:'',
      writeOffThreeReimbursment: 0,
      ucrCost:props.initialValues.ucrCost
    }
  }

  /*
  Actions
  ------------------------------------------------------------
  */



  getInput(props) {
    return new Input(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }


  getInputGroup(props) {
    return new InputGroup(props);
  }


  handleFormSubmit=(values)=>{
    this.props.changePercent(values)
    //this.props.nextStep(5)
  }

  changeDiscount=(discount)=>{
    this.setState({discount:((discount==''||discount==null)?0:discount)})
  }

  onChangeWriteOff=(whichWriteOff,writeOffPercent)=>{
    if(whichWriteOff=='writeOffOne'){
      let writeOffOneReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffOneReimbursment:writeOffOneReimbursment,writeOffOne:writeOffPercent})
    }
    if(whichWriteOff=='writeOffTwo'){
      let writeOffTwoReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffTwoReimbursment:writeOffTwoReimbursment,writeOffTwo:writeOffPercent})
    }
    if(whichWriteOff=='writeOffThree'){
      let writeOffThreeReimbursment=this.props.initialValues.ucrCost*((100-writeOffPercent)/100)
      this.setState({...this.state,writeOffThreeReimbursment:writeOffThreeReimbursment,writeOffThree:writeOffPercent})
    }
  }

  handleKeyDown = (e) => {
    if(e.key == "Enter") {
      e.preventDefault();
      this.submitRef.current.click()
    }
  }


  /*
  Render
  ------------------------------------------------------------
  */
  render() {

    //if(this.state.ucrCost==null) this.props.change('discount',0)
    const {
        handleSubmit,
        submitting
      } = this.props;

      let full=this.props.initialValues.ucrCost*((100-this.state.discount)/100)
      let profit=full-this.props.initialValues.overheadCost;

    return (
      <form className="form-horizontal">
        <div className="container" styleName="tab4">
          <div styleName="introtext">
            <p>Almost there.</p>
            <div styleName="offer-discount" onKeyDown={this.handleKeyDown.bind(this)}>
                <span>Right now, what is your average write-off for this insurance network?</span>
                <span styleName="write-off">
                <Field type="number"
                  name="writeOffOne"
                  component={this.getInputGroup}
                  label=""
                  onChange={(evt) => { this.onChangeWriteOff('writeOffOne',evt.target.value);}}
                  rightAddon="%"
                />
                </span>
            </div>
            {/* <p><b>Ok, time to open some eyes!</b> </p>
            <p>Enter up to three write-off percentages to see how many patients you’d need to retain to break even at each one.</p>

            <div styleName="tab-notes">
                <p>Keep in mind things like:<br/>
                -Your current write-off percentage for this carrier<br/>
                -The rate drop they’ll inevitably be telling you about soon<br/>
                -Any other percentage you think could be in the realm of possibility<br/>
                </p>
            </div>
        </div>

        <div styleName="calculations">

            <div styleName="flex-container">
                <div styleName="flex-cell"><b>WRITE-OFF</b></div>
                <div styleName="flex-cell"><b>PAID TO YOU</b></div>
                <div styleName="flex-cell"><b>COST</b></div>
                <div styleName="flex-cell"><b>PROFIT</b></div>
                <div styleName="flex-cell"><b>% NEEDED TO RETAIN</b></div>
            </div>
            <div styleName="flex-container">
                <div styleName="flex-cell">Full</div>
                <div styleName="flex-cell">${parseFloat(full).toFixed(2)}</div>
                <div styleName="flex-cell">${parseFloat(this.props.initialValues.overheadCost).toFixed(2)}</div>
                <div styleName="flex-cell">${parseFloat(profit).toFixed(2)}</div>
                <div styleName="flex-cell dhqblue"><b>100%</b></div>
            </div>
            <div styleName="flex-container">
                <div styleName="flex-cell">
                <Field type="number"
                name="writeOffOne"
                component={this.getInputGroup}
                onChange={(evt) => { this.onChangeWriteOff('writeOffOne',evt.target.value);}}
                rightAddon="%"

                />
              </div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell dhqblue">-</div>
              </div> */}
            {/* <div styleName="flex-container">
                <div styleName="flex-cell"><Field type="number"
                name="writeOffTwo"
                component={this.getInputGroup}
                onChange={(evt) => { this.onChangeWriteOff('writeOffTwo',evt.target.value);}}
                rightAddon="%"

                /></div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell dhqblue">-</div>
            </div>
            <div styleName="flex-container">
                <div styleName="flex-cell"><Field type="number"
                name="writeOffThree"
                component={this.getInputGroup}
                onChange={(evt) => { this.onChangeWriteOff('writeOffThree',evt.target.value);}}

                rightAddon="%"
                /></div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell">-</div>
                <div styleName="flex-cell dhqblue">-</div>
              </div> */}

          </div>

          <div styleName="nextbutton">
                <a className="btn btn-primary" styleName="large-button--primary" onClick={handleSubmit(this.handleFormSubmit)} ref={this.submitRef}>HOW MANY DO I NEED TO KEEP?</a>
          </div>
      </div>

      </form>
    );
  }
}
